/* eslint-disable no-underscore-dangle */
/* eslint-disable no-param-reassign */
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { StylesManager, Model } from "survey-core";
import { useSelector } from "react-redux";
import { Survey } from "survey-react-ui";
import JsonCollapse from "../../Components/JsonCollapse";
import getSurveyData from "./helpers/getSurveyData";
import "survey-core/defaultV2.css";
import { selectSurveyThemes } from "../../../store/slices/surveyThemesSlice";

StylesManager.applyTheme("defaultV2");

export default function SurveyModal({ state, eventHandlers }) {
  const themes = useSelector(selectSurveyThemes);
  const previewJSON = getSurveyData(state, eventHandlers);
  const [show, setShow] = useState(false);

  previewJSON.triggers.forEach((item) => {
    item.expression = item._expression;
  });
  previewJSON.completedHtmlOnCondition.forEach((item) => {
    item.expression = item._expression;
  });
  previewJSON.pages.forEach((page) =>
    page.elements?.forEach((panel) => {
      panel.visibleIf = panel._visibleIf;
      panel.elements?.forEach((innerPanel) => {
        innerPanel.visibleIf = innerPanel._visibleIf;
        innerPanel.elements?.forEach((question) => {
          question.defaultValue = question._defaultValue;
          question.min = question._min;
          question.max = question._max;
          question.choices = question._choices;
        });
      });
    })
  );

  const [survey, setSurvey] = useState(null);

  useEffect(() => {
    if ((themes, show)) {
      const theme = themes.find(
        (t) => t.UUID === (state.SurveyThemeUUID || "default")
      );
      const s = new Model({
        ...previewJSON,
        logo: theme.Logo,
      });
      s.onComplete.add(() => console.log(s, s.data));
      s.applyTheme(theme.Config);
      setSurvey(s);
    }
  }, [themes, show]);

  return (
    <>
      <button
        type="button"
        className="btn btn-link p-0"
        onClick={() => setShow(true)}
      >
        preview survey
      </button>
      <Modal
        style={{ zIndex: 2000 }}
        size="xl"
        backdropClassName="z-1900"
        show={show}
        onHide={() => {
          setShow(false);
          setSurvey(null);
        }}
      >
        <Modal.Body>
          {survey && <Survey model={survey} />}
          <JsonCollapse json={previewJSON} />
        </Modal.Body>
      </Modal>
    </>
  );
}
